if (!customElements.get('beefy-inbox-companion')) {
  customElements.define(
    'beefy-inbox-companion',
    class BeefyInboxCompanion extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('[data-beefy-inbox-image]');
        this.fallback = this.querySelector('[data-beefy-inbox-fallback]');
        this.onImageError = () => {
          if (this.image) this.image.hidden = true;
          if (this.fallback) this.fallback.hidden = false;
        };
        this.onViewportChange = () => this.queueCollisionCheck();

        this.chatObserver = new MutationObserver(() => this.queueChatCheck());
        this.chatObserver.observe(document.documentElement, { childList: true, subtree: true });

        this.image?.addEventListener('error', this.onImageError, { once: true });
        window.addEventListener('resize', this.onViewportChange, { passive: true });
        window.addEventListener('scroll', this.onViewportChange, { passive: true });
        this.queueChatCheck();

        const seconds = Number.parseInt(this.dataset.greetingDelay || '0', 10);
        const delay = Math.max(0, Number.isFinite(seconds) ? seconds : 0) * 1000;
        this.greetingTimer = window.setTimeout(() => {
          this.classList.add('beefy-inbox--ready');
          this.queueCollisionCheck();
        }, delay);
      }

      disconnectedCallback() {
        window.clearTimeout(this.greetingTimer);
        window.cancelAnimationFrame(this.collisionFrame);
        window.cancelAnimationFrame(this.chatFrame);
        window.removeEventListener('resize', this.onViewportChange);
        window.removeEventListener('scroll', this.onViewportChange);
        this.chatObserver.disconnect();
      }

      queueCollisionCheck() {
        window.cancelAnimationFrame(this.collisionFrame);
        this.collisionFrame = window.requestAnimationFrame(() => this.checkImportantControls());
      }

      queueChatCheck() {
        window.cancelAnimationFrame(this.chatFrame);
        this.chatFrame = window.requestAnimationFrame(() => {
          const chatFrame = document.querySelector('iframe[src*="storefront-agent-server.shopify.ai"]');
          this.classList.toggle('beefy-inbox--chat-open', Boolean(chatFrame));
        });
      }

      checkImportantControls() {
        const ownRect = this.getBoundingClientRect();
        const controls = document.querySelectorAll(
          '.product-form__submit, .shopify-payment-button, .cart__checkout-button, [name="checkout"], [data-sticky-add-to-cart]'
        );
        const overlapsControl = [...controls].some((control) => {
          const style = window.getComputedStyle(control);
          if (style.display === 'none' || style.visibility === 'hidden') return false;
          const rect = control.getBoundingClientRect();
          return (
            rect.width > 0 &&
            rect.height > 0 &&
            ownRect.left < rect.right &&
            ownRect.right > rect.left &&
            ownRect.top < rect.bottom &&
            ownRect.bottom > rect.top
          );
        });
        this.classList.toggle('beefy-inbox--avoiding-control', overlapsControl);
      }
    }
  );
}